import React, { Component } from "react";
import { List, ListItem } from "material-ui/List";
import Checkbox from "material-ui/Checkbox";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import styled from "styled-components";

const Div = styled.div`
  width: 50%;
  margin: 0 auto;
  display: ${props => props.visible};
`;

class Screens extends Component {
  constructor(props) {
    super(props);

    this.handleScreenClick = this.handleScreenClick.bind(this);
  }

  handleScreenClick(screen, event) {
    this.props.onItemClicked(screen);
  }

  render() {
    if (!Array.isArray(this.props.screens)) {
      return "";
    }
    return (
      <div
        style={{
          padding: 12,
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        {this.props.screens.map(screen => {
          return (
            <Card
              style={{
                width: 200,
                height: 300,
                margin: 20,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
              onClick={e => this.handleScreenClick(screen, e)}
            >
              <CardContent
                style={{
                  padding: 12
                }}
              >
                {screen.name}
              </CardContent>
            </Card>
          );
        })}
      </div>
    );
  }
}

export default Screens;



// WEBPACK FOOTER //
// ./src/components/Screens.js